var map = {
	"./auto_texts_hover.svg": "e6bd",
	"./emoji_hover.svg": "57eb",
	"./feedback_hover.svg": "cd55",
	"./functions_hover.svg": "1b4a",
	"./gallery_hover.svg": "ea45",
	"./profile_hover.svg": "97ea",
	"./reply_hover.svg": "2eea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06f1";